import { HttpHandler } from 'msw'

import { allergens } from './allergens'
import { categoriesProduct } from './categories'
import { createProduct } from './createProduct'
import { deleteProduct } from './deleteProduct'
import { getAllProducts } from './getAllProducts'
import { getProduct } from './getProduct'
import { importProducts } from './import'
import { subcategoriesProduct } from './subcategories'
import { updateProduct } from './updateProduct'

export const products: HttpHandler[] = [
    ...allergens,
    ...categoriesProduct,
    createProduct,
    deleteProduct,
    getAllProducts,
    getProduct,
    ...importProducts,
    ...subcategoriesProduct,
    updateProduct,
]
